import {Component, DestroyRef, inject, Input, OnChanges, SimpleChanges,} from '@angular/core';
import {DetailsConfig, SharedUiDetailsModule } from '@snelstart/ui-details';
import {ButtonConfiguration, SharedUiButtonModule } from "@snelstart/ui-button";
import {Observable} from "rxjs";
import {
  BokkzAlgDataService,
  BokkzClient, DossierItemEntity
} from "@snelstart-ventures/fiscaal/domain-logic";
import {ToastService} from "@snelstart/ui-toast";
import {ActivatedRoute} from "@angular/router";
import { FeatureWorkflowItemComponent } from '../workflow-item/feature-workflow-item.component';
import {takeUntilDestroyed} from "@angular/core/rxjs-interop";

@Component({
  selector: 'snelstart-venture-fiscaal-feature-tax-workflow-details',
  templateUrl: './feature-tax-workflow-details.component.html',
  styleUrl: './feature-tax-workflow-details.component.scss',
  imports: [
    SharedUiDetailsModule,
    FeatureWorkflowItemComponent,
    SharedUiButtonModule,
  ],
})
export class FeatureTaxWorkflowDetailsComponent implements OnChanges {

  @Input() public id!: string;
  private readonly destroyRef = inject(DestroyRef);
  private readonly bokkzClient = inject(BokkzClient);
  private readonly bokkzAlgDataService = inject(BokkzAlgDataService);
  private readonly activatedRoute = inject(ActivatedRoute);
  private readonly toastService = inject(ToastService);

  public sstRelationId = null as unknown as string;
  public dossierItem = {} as DossierItemEntity;

  protected readonly detailsConfig = DetailsConfig.create({
    hideArrowButtons: true,
  });

  ngOnChanges(changes: SimpleChanges): void {
    const idChange = changes['id'];
    if (!idChange) {
      return;
    }

    const dossierItem = idChange.currentValue as string | undefined;
    if (!dossierItem) {
      return;
    }

    this.activatedRoute.parent?.paramMap.pipe(takeUntilDestroyed(this.destroyRef)).subscribe((paramMap) => {
      if (paramMap.get('clientId')) {
        this.sstRelationId = paramMap.get('clientId')!;
      }
    });

    if (this.sstRelationId != null) {
      this.bokkzClient
        .getDossierItem(String(this.sstRelationId), String(this.id))
        .pipe(takeUntilDestroyed(this.destroyRef))
        .subscribe((dossierItem) => {
          if (dossierItem) {
            this.dossierItem = dossierItem;
            this.bokkzAlgDataService.updateWorkflowItem(dossierItem);
          }
        });
    }
  }

  public configSave() {
    return ButtonConfiguration.create({
      onClick: () =>
        new Observable((subscription) => {
          setTimeout(() => {
            this.saveForm();
            subscription.next(true);
            subscription.complete();
          }, 200);
        }),
    });
  }

  saveForm(): void {
    this.bokkzClient
      .postDossierItem(String(this.sstRelationId), this.dossierItem)
      .pipe(takeUntilDestroyed(this.destroyRef))
      .subscribe((dossierItemEntity) => {
        if (dossierItemEntity) {
          this.toastService.showSuccessMessage(
            'Het dossier item is succesvol opgeslagen.',
          );
        } else {
          this.toastService.showWarningMessage(
            'Het dossier item is niet succesvol omgezet.',
          );
        }
      });
  }
}
